import Login from '../../spa/login/login';

export default {
    path: 'login',
    name: 'login',
    component: Login,
};


// WEBPACK FOOTER //
// ./src/config/router/login.js